var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7C7.5 7.27614 7.72386 7.5 8 7.5H13V13C13 13.5523 12.5523 14 12 14H4C3.44772 14 3 13.5523 3 13V3C3 2.44772 3.44772 2 4 2H7.5V7ZM5 11C4.72386 11 4.5 11.2239 4.5 11.5C4.5 11.7761 4.72386 12 5 12H7C7.27614 12 7.5 11.7761 7.5 11.5C7.5 11.2239 7.27614 11 7 11H5ZM5 9C4.72386 9 4.5 9.22386 4.5 9.5C4.5 9.77614 4.72386 10 5 10H10C10.2761 10 10.5 9.77614 10.5 9.5C10.5 9.22386 10.2761 9 10 9H5ZM12.6875 6.5H8.5V2.47949L12.6875 6.5Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile2);
export default __webpack_public_path__ + "static/media/File_2.4c9f68f76e42ad5e633abfdf198c27d0.svg";
export { ForwardRef as ReactComponent };